
<template>
  <v-footer v-if="usuarioLogado" color="#E65100" width="auto" style="justify-content: center;">
    <p class="textofooter">COPYRIGHT © {{ mostraAnoAtual() }} - AICHEFF INTELITE</p>
    <!-- <span><img  class="imagemLogoFooter" src="../assets/logo-mini.png" alt="" height="30" width="auto"></span> -->
    <v-spacer></v-spacer>
    <v-btn icon dark href="https://www.instagram.com/intelite_tecnologia/" target="_blank">
      <img src="../assets/instagram.png">
    </v-btn>
  </v-footer>
</template>

<script>
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    data () {
      return {
      }
    },

    mounted: function () { 
      if (sessionStorage.getItem('accToken') != null)
        this.$store.dispatch('Logar', this.token)
    },

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      username: state => state.UserName
    }),

    methods: {
      mostraAnoAtual() {
        return moment().format('YYYY')
      }
    },
  }
</script>

<style>
  .textofooter {
    font-size: 11px;
    position:absolute;
    color: white;
    /* right: 42%; */
    /* left: 42%; */
    margin-right: -50px;
    margin-left: -50px;
  }

  .imagemLogoFooter {
    margin-left: 45px;
    left: 5%;
  }
</style>
